"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.map = map;
exports.forEach = forEach;
exports.count = count;
exports.filter = filter;
exports.find = find;
exports.every = every;
exports.some = some;
exports.toArray = toArray;
const react_1 = __importDefault(require("react"));
function map(children, func, context) {
    let index = 0;
    return react_1.default.Children.map(children, (child) => {
        if (!react_1.default.isValidElement(child)) {
            return child;
        }
        return func.call(context, child, index++);
    });
}
function forEach(children, func, context) {
    let index = 0;
    react_1.default.Children.forEach(children, (child) => {
        if (!react_1.default.isValidElement(child)) {
            return;
        }
        func.call(context, child, index++);
    });
}
function count(children) {
    let result = 0;
    react_1.default.Children.forEach(children, (child) => {
        if (!react_1.default.isValidElement(child)) {
            return;
        }
        ++result;
    });
    return result;
}
function filter(children, func, context) {
    let index = 0;
    const result = [];
    react_1.default.Children.forEach(children, (child) => {
        if (!react_1.default.isValidElement(child)) {
            return;
        }
        if (func.call(context, child, index++)) {
            result.push(child);
        }
    });
    return result;
}
function find(children, func, context) {
    let index = 0;
    let result;
    react_1.default.Children.forEach(children, (child) => {
        if (result) {
            return;
        }
        if (!react_1.default.isValidElement(child)) {
            return;
        }
        if (func.call(context, child, index++)) {
            result = child;
        }
    });
    return result;
}
function every(children, func, context) {
    let index = 0;
    let result = true;
    react_1.default.Children.forEach(children, (child) => {
        if (!result) {
            return;
        }
        if (!react_1.default.isValidElement(child)) {
            return;
        }
        if (!func.call(context, child, index++)) {
            result = false;
        }
    });
    return result;
}
function some(children, func, context) {
    let index = 0;
    let result = false;
    react_1.default.Children.forEach(children, (child) => {
        if (result) {
            return;
        }
        if (!react_1.default.isValidElement(child)) {
            return;
        }
        if (func.call(context, child, index++)) {
            result = true;
        }
    });
    return result;
}
function toArray(children) {
    const result = [];
    react_1.default.Children.forEach(children, (child) => {
        if (!react_1.default.isValidElement(child)) {
            return;
        }
        result.push(child);
    });
    return result;
}
exports.default = {
    map,
    forEach,
    count,
    filter,
    find,
    every,
    some,
    toArray
};
//# sourceMappingURL=valid-element-children.js.map